<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CkMhEP/tc-custom/9781617753343.jpg?1721429532182" alt="This image is the cover for the book Tehran Noir, Akashic Noir"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tehran Noir, Akashic Noir
      </h1>
      <p class="bookDescription body article font2">
        <b>Crime fiction set in Iran—including a finalist for the Shamus Award for Best PI Short Story.</b><br/>  <br/> “<i>Tehran Noir</i> is not only a solid crime collection, but an illuminating look into day-to-day life in the Middle East, with religious and political implications galore, as well as racial tensions bubbling just beneath the surface. . . . The stories in <i>Tehran Noir</i> aren’t always easy to read, but they are engaging in the extreme.” —<i>San Francisco Book Review</i><br/>  <br/> Includes brand-new stories by Gina B. Nahai, Salar Abdoh, Lily Farhadpour, Azardokht Bahrami, Yourik Karim-Masihi, Vali Khalili, Farhaad Heidari Gooran, Aida Moradi Ahani, Mahsa Mohebali, Majed Neisi, Danial Haghighi, Javad Afhami, Sima Saeedi, Mahak Taheri, and Hossein Abkenar.<br/>  <br/> “A stellar and diverse cast of Iranian writers. . . . A collection such as this is able to bring Iran to life for the foreign reader in a way other fiction and non-fiction cannot. . . . Superb.” —<i>PopMatters</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Salar Abdoh
      </h2>
      
      <p class="authorDescription body article"><B>Salar Abdoh</B> was born in Iran, and splits his time between Tehran and New York City, where he is codirector of the Creative Writing MFA Program at the City College of New York. He is the author of <I>The Poet Game</I> and <I>Opium</I>. His essays and short stories have appeared in various publications, including the <I>New York Times</I>, <I>BOMB</I>, <I>Callaloo</I>, <I>Guernica</I>, and on the BBC. He is the recipient of the NYFA Prize and the National Endowment for the Arts award. He is the editor of <I>Tehran Noir</I> and the author of <I>Tehran at Twilight</I>, his latest novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Akashic Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ea20e3b